export default __webpack_public_path__ + "static/media/404.f5b43648.png";